import { useMutationWithToaster } from "hooks";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";

function mutationFactory() {
  const query = `
    mutation updateInsightLicense($userId: ID!, $enableInsights: Boolean!) {
      updateInsightLicense(userId: $userId, enableInsights: $enableInsights) {
        eligibility {
          eligible
          cause
        }
      }
    }`;

  const resolver = ({ data: { updateInsightLicense } = {}, errors }) => {
    if (errors) throw errors;

    if (updateInsightLicense?.eligibility?.eligible)
      return {
        data: { successMessage: updateInsightLicense.eligibility.cause },
      };

    const error = [{ message: updateInsightLicense?.eligibility?.cause }];
    throw error;
  };

  return { query, resolver };
}

export function useInsightsLicenseAction(onDone) {
  const [enableUserInsights, { loading: isRunning }] = useMutationWithToaster(
    mutationFactory,
    { onDone }
  );

  return {
    isSubmitting: isRunning,
    enableUserInsights: (user, enable) => {
      return enableUserInsights(
        {
          userId: toGlobalId("Advisor", user.id),
          enableInsights: enable,
        },
        {
          defaultErrorMsg: `Failed to ${
            enable ? "enable" : "disable"
          } insights for ${
            user.name
          }, please retry or contact support for assistance`,
        }
      );
    },
  };
}

export default useInsightsLicenseAction;
